/**
 * Configuration for users in this app.
 */
const jobiqoUserConfig = require('./../src/jobiqo/config/user');
const mergeDeepRight = require('ramda/src/mergeDeepRight');
module.exports = mergeDeepRight(jobiqoUserConfig, {
  // Insert config here. this will be deep merged with config from jobiqo. Arrays are not deep mergeable
  // so make sure to cover those with [...jobiqoCompanyConfig.public.SOME_KEY_THAT_IS_ARRAY, new_item ]
});
